<template>
  <button
    v-if="toggle.userExamDocument && !toggle.covax"
    id="BtnFilterDocuments"
    class="btn document-filter btn-regular-size"
    :class="[
      { 'document-filter-active': isButtonActive },
      { 'document-filter-loading': loading },
      'document-filter-' + status
    ]"
    @click="redirectToDocumentsRequired()"
  >
    <div
      v-if="loading"
      class="document-filter-loading__field"
    >
      <div class="document-filter-loading__field--darker document-filter-loading__field-1" />
      <div class="document-filter-loading__field--darker document-filter-loading__field-2" />
    </div>
    <div
      v-else
      class="document-filter__content"
    >
      <svg-loader
        v-if="totalExamsPending > 0"
        :src="'/static/images/icon-alert-' + (isButtonActive ? 'orange' : 'white') + '.svg'"
      />
      <img
        v-else
        src="/static/images/icon-success-white.png"
      >
      <div id="filterContent">
        Exames com documentos pendentes: {{ totalExamsPending }}
      </div>
      <md-tooltip v-if="totalExamsPending > 0">
        Clique aqui para filtrar.
      </md-tooltip>
    </div>
  </button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DocumentFilter',
  props: {
    totalExamsPending: Number,
    loading: Boolean
  },
  data: () => {
    return {
      isButtonActive: false
    }
  },
  computed: {
    ...mapGetters(['toggle']),
    status: function () {
      return this.totalExamsPending > 0 ? 'alert' : 'success'
    }
  },
  watch: {
    $route(to, from) {
      let params = JSON.parse(JSON.stringify(this.$route.query))
      if (params.docDelivered === false) {
        this.isButtonActive = true
      } else {
        this.isButtonActive = false
      }
    },
    loading: function (newValue) {
      if (!newValue && this.isButtonActive && this.totalExamsPending === 0) {
        let params = JSON.parse(JSON.stringify(this.$route.query))
        params.docDelivered = null
        this.redirect(params)
      }
    }
  },
  methods: {
    redirectToDocumentsRequired() {
      if (this.totalExamsPending > 0 && !this.loading) {
        this.$router.replace('/documentos-obrigatorios')
        this.submitAnalyticsEvent('Visualizar documentos pendentes')
      }
    },
    redirect(params) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, params)
      })
    },
    submitAnalyticsEvent(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Upload de Documentos Pendentes',
        action: action,
        label: this.$route.path
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../static/stylesheets/variables';

.document-filter {
  width: auto;
  height: 30px;
  margin-left: 10px;
  font-family: 'Exo 2', sans-serif !important;
  font-size: 13px;
  letter-spacing: 1px;
  line-height: 16px;
  font-weight: 500;
  text-transform: lowercase;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 14px;
  padding-left: 14px;

  &-alert {
    background-color: #fb8a00;
  }

  &-success {
    background-color: #21d09b;
    cursor: default;
  }

  &-active {
    border: 2px solid #fb8a00;
    background: none;
    color: #fb8a00;
  }

  &__content {
    display: flex;
    align-items: center;

    img {
      margin-right: 10px;
    }

    .md-icon {
      padding: 5px;
      width: 24px;
      height: 25px;
    }
  }

  &-loading {
    border-radius: 6px;
    background-color: #fff;
    animation: loading 1.5s infinite;
    background-position: -400px;
    background-size: 100% 100%;
    background-image: linear-gradient(90deg, hsla(0, 20%, 97.1%, 0.4), hsla(0, 2.1%, 62.7%, 0.2) 50%, hsl(0, 0%, 100%));
    background-repeat: no-repeat;
    cursor: progress;

    &__field {
      display: flex;

      &--darker {
        height: 14px;
        opacity: 0.1;
        border-radius: 3px;
        background-color: #111111;
      }

      &-1 {
        margin: 0 5px 0 0;
        height: 20px;
        width: 20px;
      }

      &-2 {
        margin: 0 0 0 5px;
        height: 20px;
        width: 270px;
      }
    }
  }
}

@keyframes loading {
  to {
    background-position: 400px;
  }
}
</style>
